module.exports = __webpack_public_path__ + "static/media/download.c72d82fd.svg";